import {
    Document,
    Page,
    View,
} from '@react-pdf/renderer';

import styles from './styles/styles';
import Header from './components/header';
import Overview from './components/overview';
import Summary from './components/summary';
import Footer from './components/footer';
import Details from './components/details';

interface Species {
    abr: string;
    lat: string;
}

interface WoodLogDeliveryNoteProps {
    printLogo: string | undefined;
    headerLabels: {
        title: string;
        date: string;
        buyer: string;
        seller: string;
        measuredBy: string;
        forest: string;
        certificate: string;
        claims: string;
        note: string;
    };
    headerData: {
        date: string;
        buyer: string;
        seller: string;
        measuredBy: string;
        forest: string;
        certificateNumber: string;
        claims: string;
        note: string;
    };

    overviewLabels: {
        header: string;
        stackNumber: string;
        assortment: string;
        species: string;
        effectiveLength?: string;
        avgDiameter?: string;
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
        map: string;
        gps: string;
        nearestAddress: string;
        origin: string;
        link: { label: string; href: string };
        measMethod?: string;
        longestLog?: string;
        shortestLog?: string;
        avgLength?: string;
        avgVol?: string;
    };
    overviewData: {
        stackNumber: string;
        assortment: string;
        species: Species[];
        effectiveLength?: string;
        avgDiameter?: string;
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
        gpsCoordinates: { lat: number; long: number };
        nearestAddress?: string;
        origin: string;
        measMethod?: string;
        longestLog?: string;
        shortestLog?: string;
        avgLength?: string;
        avgVol?: string;
    };

    summeryHeader: string;
    summaryTableHeader: string[];
    summaryRows: [string, ...string[]][];

    detailsHeader: string;
    detailsTableHeader: string[];
    detailsRows: [string, ...string[]][];

    stackDeliveryNoteFooter: string;
}

const WoodLogDeliveryNote = ({
    printLogo,
    headerLabels,
    headerData,

    overviewLabels,
    overviewData,

    summeryHeader,
    summaryTableHeader,
    summaryRows,

    detailsHeader,
    detailsTableHeader,
    detailsRows,

    stackDeliveryNoteFooter
}: WoodLogDeliveryNoteProps) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <Header
                        labels={headerLabels}
                        data={headerData}
                        logoSrc={printLogo}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Overview
                        labels={overviewLabels}
                        data={overviewData}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Summary
                        summeryHeader={summeryHeader}
                        summaryTableHeader={summaryTableHeader}
                        summaryRows={summaryRows}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Details
                        detailsHeader={detailsHeader}
                        detailsTableHeader={detailsTableHeader}
                        detailsRows={detailsRows}
                    />
                </View>

                <Footer footerText={stackDeliveryNoteFooter} />
            </Page>
        </Document>
    );
}

export default WoodLogDeliveryNote;
